"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enableApplyNextButton = void 0;
/* ========================================================================
    Module: Enable apply next button
 ========================================================================== */
const applyNextButtons = document.querySelectorAll(".js-apply-next-button");
const agreeCheckboxes = document.querySelectorAll(".js-agree-checkbox");
/**
 * 注意事項の同意がすべてチェックされていればボタンを有効化する
 *
 * @returns {void}
 */
const enableApplyNextButton = () => {
    if (applyNextButtons.length <= 0 || agreeCheckboxes.length <= 0) {
        return;
    }
    enableButton();
    agreeCheckboxes.forEach((element) => {
        element.addEventListener("change", (e) => {
            enableButton();
        });
    });
};
exports.enableApplyNextButton = enableApplyNextButton;
/**
 * ボタンを有効にする
 *
 * @returns {void}
 */
const enableButton = () => {
    let checkedNum = 0;
    agreeCheckboxes.forEach((element) => {
        if (element.checked) {
            checkedNum++;
        }
    });
    if (agreeCheckboxes.length === checkedNum) {
        applyNextButtons.forEach((element) => {
            element.disabled = false;
        });
    }
    else {
        applyNextButtons.forEach((element) => {
            element.disabled = true;
        });
    }
};
